import React from 'react'

import { Post, MyEvent, Event } from '../../../types'
import { DefaultUserPicture, UserPicture } from '../../../components'

export const getPostAvatar = ({
  post,
  events,
}: {
  post: Post
  events: (MyEvent | Event)[]
}): React.ReactElement => {
  const { userAlias, user } = post
  const event = events.find(ev => ev.id === post?.eventId)

  if (userAlias && event?.mainImage) {
    return <UserPicture name={event.mainImage} url={event?.mainImage} />
  }

  if ((userAlias && !event?.mainImage) || !user?.avatarUrl || !event) {
    return <DefaultUserPicture />
  }

  return <UserPicture name={event.mainImage} url={user.avatarUrl} />
}
